
import React from 'react'
import PageWrapper from '../../Components/Other/PageWrapper'
import { useEffect } from 'react';
import DetailHeader from '../../Components/DiseaseDetail/DetailHeader'
function Appendix(props) {
    useEffect(() => {

    })
    return (
        <PageWrapper className={"dis-05-autism-page"}>
            <>
                {/*?php include 'header.php'; ?*/}
                <div className="pageWrapper">
                    <DetailHeader diseaseName={"Appendix"}></DetailHeader>
                    <div className="MainContent">
                        <div className="container">
                            <div className="page-rte">
                                <p>The appendix is <b>a narrow, finger-shaped pouch that projects
                                    out from the colon.</b> Appendicitis occurs when the appendix
                                    becomes inflamed and filled with pus. Appendicitis is an
                                    inflammation of the appendix, a finger-shaped pouch that
                                    projects from your colon on the lower right side of your
                                    abdomen</p>

                                <div className="row">
                                    <div className="col-12 textCenter">
                                        <img src={require("../../img/Disease/Appendix/1.png")} alt="Appendix" />
                                    </div>
                                </div>
                                <br></br>
                                <p><b>Symptoms</b></p>
                                <p>Sudden pain that begins on the right side of the lower abdomen</p>
                                <p>Sudden pain that begins around your navel and often shifts to your lower right abdomen</p>
                                <p>Pain that worsens if you cough, walk or make other jarring movements</p>
                                <p>Nausea and vomiting</p>
                                <p>Loss of appetite</p>
                                <p>Low-grade fever that may worsen as the illness progresses</p>
                                <p>Constipation or diarrhea</p>
                                <p>Abdominal bloating</p>
                                <p>Flatulence</p>
                                <a className="links" href="https://en.wikipedia.org/wiki/Appendix_(anatomy">
                                    For More Details
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
                {/*?php include 'footer.php'; ?*/}
            </>

        </PageWrapper>
    );
}

export default Appendix;